module.exports = __webpack_public_path__ + "img/grey.7ad0e1be.png";